import React from "react";

const Sofort = (props) => {
  return (
    <svg
      height={32}
      width={32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" fill="#f9809f" />
        <path
          d="M16.279 7c0 3.307-1.501 6.342-4.124 8.323l-1.573 1.2 6.126 8.442h5.034l-5.638-7.77C18.777 14.504 20.27 10.888 20.27 7zM6 7h4.087v17.965H6zm16.382 15.665c0-1.289 1.034-2.335 2.309-2.335S27 21.376 27 22.665C27 23.955 25.966 25 24.69 25s-2.308-1.046-2.308-2.335z"
          fill="#fff"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export default Sofort;
